import React, { useEffect, useState } from "react";
import { getprofitandloss } from "../../../../services/admin";
import moment from "moment";
import baseUrl from "../../../../Api";
import { printReportUrl } from "../../../../utils/printPdf";

export default function ProfitAndLoss() {
    const [startDate, setStartDate] = useState(moment().startOf('year').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = () => {
        setLoading(true);
        const data = {
            start_date: startDate,
            end_date: endDate,
            branch_id: localStorage.getItem("branch"),
        };

        getprofitandloss(data).then((res) => {
            if (res.status === true) {
                console.log("Profit & Loss Response:", res.data);
                setReportData(res.data);
            } else {
                console.error("Profit & Loss Error:", res.message);
            }
            setLoading(false);
        }).catch((error) => {
            console.error("Profit & Loss API Error:", error);
            setLoading(false);
        });
    };

    const handleGenerate = () => {
        fetchReport();
    };

    const handleDownloadPDF = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/profitandloss/pdf?start_date=${startDate}&end_date=${endDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ProfitAndLoss_${moment(startDate).format('DD-MM-YYYY')}_to_${moment(endDate).format('DD-MM-YYYY')}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading PDF:', error);
            alert('Error downloading PDF');
        });
    };

    // Print sends the same PDF the download button produces straight to the printer.
    const handlePrint = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        printReportUrl(`${baseUrl}/profitandloss/pdf?start_date=${startDate}&end_date=${endDate}&branch_id=${branchId}&output=html`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
    };

    const handleDownloadExcel = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/profitandloss/excel?start_date=${startDate}&end_date=${endDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ProfitAndLoss_${moment(startDate).format('DD-MM-YYYY')}_to_${moment(endDate).format('DD-MM-YYYY')}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        });
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Profit & Loss Statement</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Profit & Loss
                    </li>
                </ol>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}

            {!loading && (
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Profit & Loss Statement</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            {reportData && (
                                                <>
                                                    <button className="btn btn-danger me-2" onClick={handleDownloadPDF}>
                                                        <i className="fa fa-file-pdf"></i> Download PDF
                                                    </button>
                                                    <button className="btn btn-success me-2" onClick={handleDownloadExcel}>
                                                        <i className="fa fa-file-excel"></i> Download Excel
                                                    </button>
                                                    <button className="btn btn-primary" onClick={handlePrint}>
                                                        <i className="fa fa-print"></i> Print
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                            <div className="row mb-4">
                                <div className="col-md-3">
                                    <label className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">To Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleGenerate}
                                        disabled={loading}
                                    >
                                        <i className="fa fa-search"></i> {loading ? 'Loading...' : 'Generate'}
                                    </button>
                                </div>
                            </div>

                            {reportData && (
                                <>
                                    <div className="text-center mb-4">
                                        <h5>Profit & Loss Statement</h5>
                                        <p className="text-muted">
                                            For the period from {moment(reportData.period?.start_date || startDate).format('DD-MM-YYYY')}
                                            {' '}to {moment(reportData.period?.end_date || endDate).format('DD-MM-YYYY')}
                                        </p>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead className="table-light">
                                                <tr>
                                                    <th width="60%">Particulars</th>
                                                    <th width="20%" className="text-end">Amount (₹)</th>
                                                    <th width="20%" className="text-end">Total (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Income Section */}
                                                <tr className="table-info">
                                                    <td><strong>INCOME</strong></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>

                                                {Object.entries(reportData.income?.groups || {}).map(([groupName, groupData], idx) => (
                                                    <React.Fragment key={`income-group-${idx}`}>
                                                        <tr>
                                                            <td className="ps-3"><strong>{groupName}</strong></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        {groupData.accounts.map((account, accIdx) => (
                                                            <tr key={`income-acc-${accIdx}`}>
                                                                <td className="ps-5">{account.account_name}</td>
                                                                <td className="text-end">{formatCurrency(account.amount)}</td>
                                                                <td></td>
                                                            </tr>
                                                        ))}
                                                        <tr>
                                                            <td className="ps-4"><em>Total {groupName}</em></td>
                                                            <td></td>
                                                            <td className="text-end"><strong>{formatCurrency(groupData.total)}</strong></td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}

                                                <tr className="table-secondary">
                                                    <td><strong>TOTAL INCOME</strong></td>
                                                    <td></td>
                                                    <td className="text-end"><strong>{formatCurrency(reportData.income?.total || 0)}</strong></td>
                                                </tr>

                                                {/* Expense Section */}
                                                <tr className="table-warning">
                                                    <td><strong>EXPENSES</strong></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>

                                                {Object.entries(reportData.expense?.groups || {}).map(([groupName, groupData], idx) => (
                                                    <React.Fragment key={`expense-group-${idx}`}>
                                                        <tr>
                                                            <td className="ps-3"><strong>{groupName}</strong></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        {groupData.accounts.map((account, accIdx) => (
                                                            <tr key={`expense-acc-${accIdx}`}>
                                                                <td className="ps-5">{account.account_name}</td>
                                                                <td className="text-end">{formatCurrency(account.amount)}</td>
                                                                <td></td>
                                                            </tr>
                                                        ))}
                                                        <tr>
                                                            <td className="ps-4"><em>Total {groupName}</em></td>
                                                            <td></td>
                                                            <td className="text-end"><strong>{formatCurrency(groupData.total)}</strong></td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}

                                                <tr className="table-secondary">
                                                    <td><strong>TOTAL EXPENSES</strong></td>
                                                    <td></td>
                                                    <td className="text-end"><strong>{formatCurrency(reportData.expense?.total || 0)}</strong></td>
                                                </tr>

                                                {/* Net Profit/Loss */}
                                                <tr className={(reportData.net_profit || 0) >= 0 ? 'table-success' : 'table-danger'}>
                                                    <td><strong>{(reportData.net_profit || 0) >= 0 ? 'NET PROFIT' : 'NET LOSS'}</strong></td>
                                                    <td></td>
                                                    <td className="text-end">
                                                        <strong>{formatCurrency(Math.abs(reportData.net_profit || 0))}</strong>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {(reportData.net_profit || 0) >= 0 && (
                                        <div className="alert alert-success mt-3">
                                            <i className="fa fa-check-circle"></i> Net Profit Margin: {reportData.net_profit_percentage || 0}%
                                        </div>
                                    )}

                                    {(reportData.net_profit || 0) < 0 && (
                                        <div className="alert alert-danger mt-3">
                                            <i className="fa fa-exclamation-triangle"></i> Loss Percentage: {Math.abs(reportData.net_profit_percentage || 0)}%
                                        </div>
                                    )}
                                </>
                            )}

                            {!reportData && !loading && (
                                <div className="text-center py-5">
                                    <p className="text-muted">Click "Generate" to view the Profit & Loss Statement</p>
                                </div>
                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
}
